import { SelectItemV2, WorkflowItem } from '@schenck/rotec-components';
import { Priority, TaskType, ResponsibleCompany } from '../../api/task-base.model';

export const PRIORITY_ITEMS: SelectItemV2<string>[] = [
  { name: 'High', value: Priority.High },
  { name: 'Medium', value: Priority.Medium },
  { name: 'Low', value: Priority.Low },
];

export const KIND_OF_TASK_ITEMS: SelectItemV2<string>[] = [
  { name: 'Electrical', value: TaskType.Electrical },
  { name: 'Mechanical', value: TaskType.Mechanical },
  { name: 'IT', value: TaskType.IT },
  { name: 'Other', value: TaskType.Other },
];

export const RESPONSIBLE_COMPANY_ITEMS: SelectItemV2<string>[] = [
  { name: 'Schenck', value: ResponsibleCompany.Schenck },
  { name: 'Customer', value: ResponsibleCompany.Customer },
];

export const WORKFLOW_ITEMS_UPLOAD_MACHINE_TASKLIST: WorkflowItem[] = [
  { title: 'Machines', valid: false },
  { title: 'Select Tasklist', valid: false },
];

export const WORKFLOW_ITEMS_UPLOAD_TOOLING_TASKLIST: WorkflowItem[] = [
  { title: 'Tooling', valid: false },
  { title: 'Select Tasklist', valid: false },
];

export const MACHINE_WORKFLOW_ITEMS: WorkflowItem[] = [
  { title: 'Machine', valid: false },
  { title: 'Description', valid: false },
  { title: 'Scheduling', valid: false },
  { title: 'Documents', valid: false },
];

export const TOOLING_WORKFLOW_ITEMS: WorkflowItem[] = [
  { title: 'Tooling', valid: false },
  { title: 'Description', valid: false },
  { title: 'Scheduling', valid: false },
  { title: 'Documents', valid: false },
];
